import { TopBar } from "@/components/dashboard/TopBar";
import { DailyPractice } from "@/components/dashboard/DailyPractice";
import { TodaySection } from "@/components/dashboard/TodaySection";
import { InsightsSection } from "@/components/dashboard/InsightsSection";
import { StepWork } from "@/components/dashboard/StepWork";
import { ToolsSection } from "@/components/dashboard/ToolsSection";
import { TellAFriend } from "@/components/dashboard/TellAFriend";
import { JournalSection } from "@/components/dashboard/JournalSection";
import { Sidebar } from "@/components/dashboard/Sidebar";
import { Footer } from "@/components/dashboard/Footer";

export default function Dashboard() {
  return (
    <div className="relative z-10 min-h-screen bg-gradient-canvas">
      <TopBar />
      <main className="mx-auto max-w-[1180px] px-5 pb-20 pt-10 sm:px-8 sm:pt-12">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-[minmax(0,1fr)_300px] lg:gap-14">
          <div className="min-w-0 space-y-14 sm:space-y-16">
            <DailyPractice />
            <TodaySection />
            <InsightsSection />
            <StepWork />
            <ToolsSection />
            <TellAFriend />
            <JournalSection />
            <Sidebar className="lg:hidden" />
          </div>
          <aside className="hidden lg:block">
            <Sidebar className="sticky top-20" />
          </aside>
        </div>
      </main>
      <Footer />
    </div>
  );
}
